import { useState } from "react";

/**
 * п.6 ТЗ: фото повинні виглядати якісно (стабільний aspect-ratio, object-fit: cover,
 * lazy loading, skeleton/placeholder). У джерельних даних фото автомобілів відсутні
 * повністю (не помилка — просто ще немає фотобанку), тому за відсутності photoUrl
 * показуємо акуратний плейсхолдер-силует замість "зламаної картинки" чи вигаданого фото.
 */
export function PhotoWithSkeleton({ src, alt }: { src: string | null; alt: string }) {
  const [loaded, setLoaded] = useState(false);

  if (!src) {
    return (
      <div className="photo-frame">
        <div className="photo-placeholder" aria-label={`Фото ${alt} ще не додано`}>
          <CarSilhouette />
        </div>
      </div>
    );
  }

  return (
    <div className="photo-frame">
      {!loaded && <div className="photo-skeleton" />}
      <img
        src={src}
        alt={alt}
        loading="lazy"
        decoding="async"
        style={{ display: loaded ? "block" : "none" }}
        onLoad={() => setLoaded(true)}
        onError={() => setLoaded(true)}
      />
    </div>
  );
}

function CarSilhouette() {
  return (
    <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3 13l1.5-4.5A2 2 0 0 1 6.4 7h11.2a2 2 0 0 1 1.9 1.5L21 13v4a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1H6v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-4z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinejoin="round"
      />
      <circle cx="7" cy="17" r="1.4" stroke="currentColor" strokeWidth="1.4" />
      <circle cx="17" cy="17" r="1.4" stroke="currentColor" strokeWidth="1.4" />
    </svg>
  );
}
